import { cn } from "@/lib/utils";
import { CoTile } from "./parts";
import { appStatus, ago, fitTone, companyLine, TONE, DAY } from "./portal";

function listStatus(o, a, interviews) {
  if (a) {
    const s = appStatus(a, interviews);
    if (s.group === "closed") return [`Closed · ${s.label.toLowerCase()}`, "muted"];
    if (s.key === "review") return ["Applied · under review", "muted"];
    return [s.key === "assessment" ? `Applied · ${s.label.toLowerCase()}` : s.label, s.tone];
  }
  if (o.applied) return ["Applied", "muted"];
  const when = o.job.published_at || o.job.created_at;
  const fresh = when && Date.now() - Date.parse(when) < 3 * DAY;
  return [fresh ? `New · posted ${ago(when)}` : when ? `Posted ${ago(when)}` : "Open", fresh ? "green" : "muted"];
}

export function JobList({ items, activeId, onPick, appsByJob, interviews, ready, strong }) {
  return (
    <div>
      <div className="pb-3 text-sm text-muted-foreground" data-testid="jobs-count">
        {items.length} role{items.length === 1 ? "" : "s"}{ready ? ` · ${strong} strong match${strong === 1 ? "" : "es"}` : ""}
      </div>
      <ul className="space-y-2.5 hs-stagger" aria-label="Roles">
        {items.map((o) => {
          const j = o.job;
          const active = j.id === activeId;
          const [label, tone] = listStatus(o, appsByJob[j.id], interviews);
          return (
            <li key={j.id}>
              <button onClick={() => onPick(j.id)} aria-current={active ? "true" : undefined} data-testid={`job-card-${j.id}`}
                className={cn("w-full text-left rounded-[14px] border p-4 flex items-start gap-3.5 transition-colors",
                  active ? "border-primary/50 bg-primary/[0.06]" : "border-border bg-card hover:border-foreground/20")}>
                <CoTile name={o.company_name || j.title} />
                <span className="min-w-0 flex-1 leading-snug">
                  <span className="block font-semibold truncate">{j.title}</span>
                  <span className="block text-sm text-muted-foreground truncate">{companyLine(o.company_name, j)}</span>
                  <span className={cn("block text-[13px] mt-0.5 truncate", TONE[tone])} data-testid={`job-card-status-${j.id}`}>{label}</span>
                </span>
                {ready && o.fit != null && (
                  <span className="text-right shrink-0">
                    <span className={cn("block text-lg font-display font-semibold tabular-nums leading-none", fitTone(o.fit))}>{Math.round(o.fit)}%</span>
                    <span className="block text-[11px] text-muted-foreground mt-1">fit</span>
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
